import { Input, message, Popover } from "antd"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { useEffect, useState } from "react"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { useDefaultCurrencyIso } from "hooks/settings"
import { RestrictedIcon } from "components/base/restricted-icon"

interface Props extends React.ComponentProps<typeof Input> {}

export const TaskBillableRatePopover = (props: Props) => {

  const [visible, setVisible] = useState(false)
  
  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values

  const { defaultCurrencyIso } = useDefaultCurrencyIso()

  useEffect(() => {
    if (!visible && formik.values.billableRate != formik.initialValues.billableRate) {
      formik.submitForm()
    }
  }, [visible])

  useEffect(() => {
    if (formik.errors.billableRate) {
      message.error(formik.errors.billableRate)
      formik.setFieldValue('billableRate', formik.initialValues.billableRate)
    }
  }, [formik.errors.billableRate])

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Popover
          getPopupContainer={(el) => el}
          visible={visible}
          placement="bottom"
          style={{
            width: '300px',
          }}
          content={(
            <>
              <Input
                type="number"
                autoFocus
                step={0.01}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                value={task.billableRate}
                placeholder="Task rate e.g. 10.00"
                suffix={`${defaultCurrencyIso}/h`}
                onChange={(e) => {
                  formik.setFieldValue('billableRate', e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key == 'Escape') {
                    e.preventDefault()
                    e.stopPropagation()

                    formik.setFieldValue('billableRate', formik.initialValues.billableRate)

                    setVisible(false)
                  }

                  if (e.key == "Enter") {
                    e.preventDefault()
                    e.stopPropagation()

                    // This will also send submit if needed!
                    setVisible(false)
                  }

                }}
              />
            </>
          )}
          destroyTooltipOnHide
        >
          <div
            onClick={() => setVisible((v) => !v)}
          >
            <SidebarButton>
              Billable Rate
              <RestrictedIcon />
            </SidebarButton>
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          marginLeft: '8px',
        }}
      >
        { task.billableRate ? (
          <>
            {Number(task.billableRate).toFixed(2)} {defaultCurrencyIso}
          </>
        ) : (
          <>
            No task specific rate
          </>
        )}
      </div>
    </>

  )
}